import { Component, OnInit } from '@angular/core';
import { Client } from 'src/app/services/API/client';
import { toastrService } from 'src/app/services/ux/toastr.service';

@Component({
  templateUrl: './interface.component.html'
})

export class InterfaceComponent {
    celesipublik: any;
    celesiprivat: any;

    constructor(private client: Client, private toastr: toastrService){
        // this.gjenero();
    }

  ngOnInit() {
  }

  gjenero(){
    this.client.get('api/user/get-app-key')
    .then((res:any) => {
            this.celesipublik = res.public_key; 
             this.celesiprivat = res.secret_key; 
    })
    .catch((error) => {
        this.toastr.warning(error.error);
    });
}
  
}